import { useEffect, useRef, useState } from 'react'
import { shuffle } from 'lodash'
import useInterval from '@/shared/hooks/useInterval'
import { AnimatePresence, motion } from 'framer-motion'
import { BaseScreenProps } from '@/features/quiz/types'

type AdCopy = [string, string]
const AdCopies: Array<AdCopy> = [
  ['Longer lasting', 'sex'],
  ['More confidence', 'in bed'],
  ['Harder', 'erections'],
  ['Stress-free', 'intimacy'],
  ['More satisfied', 'partners'],
  ['Rekindled', 'passion'],
]

export default function EDAdCopyScreen({
  screenId,
  onChange,
}: BaseScreenProps) {
  const randomSortedCopies = useRef(shuffle(AdCopies))
  const [currentCopyIdx, setCurrentCopyIdx] = useState(0)

  useInterval(() => {
    let next = currentCopyIdx + 1
    if (next >= randomSortedCopies.current.length) next = 0
    setCurrentCopyIdx(next)
  }, 1500)

  useEffect(() => {
    // Show this screen for 2.5 to 3.5 seconds
    const randomTimeout = Math.random() * 1000 + 2500
    const timeoutId = setTimeout(() => {
      onChange(
        screenId,
        {
          id: screenId,
          type: 'number',
          answer: 1,
        },
        true,
      )
        .then()
        .catch(console.error)
    }, randomTimeout)

    return () => clearTimeout(timeoutId)
  }, [screenId, onChange])

  return (
    <div className="inset-0 mx-auto mt-32 flex max-w-3xl flex-col items-start justify-center space-y-2">
      <p className="tracking-tight text-gray-900">We{"'"}ve got you covered</p>
      <AnimatePresence initial={true} mode="wait">
        <motion.div
          key={currentCopyIdx}
          initial={{ opacity: 0, y: '30%' }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: '-30%' }}
          transition={{ duration: 0.25, ease: 'easeIn' }}
        >
          <AdCopy copy={AdCopies[currentCopyIdx]} />
        </motion.div>
      </AnimatePresence>
    </div>
  )
}

function AdCopy({ copy }: { copy: AdCopy }) {
  return (
    <p className="text-2xl font-medium">
      <span className="text-blue-600">{copy[0]}</span>{' '}
      <span className="text-gray-900">{copy[1]}</span>
    </p>
  )
}
